import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReportType } from './model/reportType.model';
import { LoginService } from './login.service';

type ReportingConfig = {
  baseUrl: string;
  paths: Record<string, string>;
};

@Injectable({ providedIn: 'root' })
export class ReportUrlService {
  private readonly config: ReportingConfig | undefined = environment.reporting as ReportingConfig | undefined;

  loginService = inject(LoginService);

  public getReportUrl(reportType: ReportType, params: Record<string, string | number> = {}): string {
    if (!this.config?.baseUrl) {
      return '';
    }

    const path = this.config.paths?.[reportType];
    if (!path) {
      return '';
    }

    const normalizedBase = this.config.baseUrl.replace(/\/$/, '');
    const resolvedPath = this.replacePlaceholders(path, params);

    let fullUrl = `${normalizedBase}${resolvedPath}`;

    // Add JWT token as URL parameter
    const token = localStorage.getItem('authToken');
    if (token) {
      const separator = fullUrl.includes('?') ? '&' : '?';
      fullUrl += `${separator}authToken=${encodeURIComponent(token)}`;
    }

    return fullUrl;
  }

  private replacePlaceholders(path: string, params: Record<string, string | number>): string {

    // Add default to params, if not present
    const user = this.loginService.user;
    if (user) {
      // if (!params['BUInternalNumber']) {
      //   params['BUInternalNumber'] = this.loginService.user?.SelectedBusinessUnit || '';
      // }
      Object.entries(user).forEach(([key, value]) => {
        if (value && !params[key]) {
          params[key] = value as string | number;
        }
      });
    }

    let output = path;
    Object.entries(params).forEach(([key, value]) => {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
      output = output.replace(regex, `${value}`);
    });
    return output;
  }

  getReportOrigin(): string {
    if (this.config?.baseUrl) {
      return this.config.baseUrl;
    }

    return environment.proxyAddress || environment.apiAddress;
  }
}
